import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';

RFIDCard.propTypes = {
  vehicle: PropTypes.object,
  row: PropTypes.object.isRequired,
  onRefresh: PropTypes.func,
};

function RFIDCard({ vehicle, row, onRefresh }) {
  const color =
    !Utils.isValid(row) || row?.status === ChargeConstants.RFIDCardStatus.NORMAL
      ? AppColors.primary
      : AppColors.gray[300];

  return (
    <div
      className="overflow-hidden position-relative"
      style={{
        border: `1px solid ${AppColors.gray[300]}`,
        borderRadius: '10px',
        backgroundColor: color,
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
          marginBottom: '5px',
        }}
      >
        {/* header */}
        <div
          className="px-4 py-6 d-flex flex-column"
          style={{
            borderBottom: `1px dashed ${AppColors.gray[300]}`,
          }}
        >
          <div className="d-flex align-items-center gap-2">
            <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>ID Tag</span>
            {Utils.isValid(row) && (
              <KTLabel
                text={ChargeHelper.Utils.getRFIDCardStatusName(row?.status)}
                isInline={true}
                size={KTLabelSize.medium}
                additionalClassName={`label-light-${ChargeHelper.Utils.getRFIDCardStatusColor(
                  row?.status
                )}`}
              />
            )}
          </div>
          <span
            style={UIHelper.buildFontStyle(
              '700',
              '38px',
              !row || row?.status === ChargeConstants.RFIDCardStatus.NORMAL
                ? AppColors.primary
                : AppColors.gray[500]
            )}
          >
            {row ? row?.idTag : 'Chưa được cấp'}
          </span>
        </div>
        {/* body */}
        <div className="px-4 py-4 d-flex flex-column">
          <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
            Thao tác thẻ RFID
          </span>
          <div className="mt-2 d-flex align-items-center gap-3">
            {!_.isNil(row) ? (
              <>
                {row?.status === ChargeConstants.RFIDCardStatus.BLOCKED &&
                  UIHelper.buildGreenButton(
                    'Khôi phục',
                    () => {
                      ChargeHelper.UI.RFID.showDialogConfirmRestoreRFID(row, () => {
                        if (onRefresh) {
                          onRefresh();
                        }
                      });
                    },
                    null,
                    true
                  )}
                {row?.status === ChargeConstants.RFIDCardStatus.NORMAL && (
                  <>
                    {UIHelper.buildGreenButton(
                      'Đổi thẻ',
                      () => {
                        ChargeHelper.UI.Vehicle.showDialogConfirmChangeRFID(vehicle, () => {
                          if (onRefresh) {
                            onRefresh();
                          }
                        });
                      },
                      null,
                      true
                    )}
                    {UIHelper.buildRedButton(
                      'Thu hồi',
                      () => {
                        ChargeHelper.UI.RFID.showDialogConfirmRevokeRFID(row, () => {
                          if (onRefresh) {
                            onRefresh();
                          }
                        });
                      },
                      null,
                      true
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {UIHelper.buildGreenButton(
                  'Cấp thẻ RFID',
                  () => {
                    ChargeHelper.UI.Vehicle.showDialogConfirmChangeRFID(vehicle, () => {
                      if (onRefresh) {
                        onRefresh();
                      }
                    });
                  },
                  null,
                  true
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* icon */}
      <div
        className="position-absolute rounded-circle d-flex align-items-center justify-content-center"
        style={{
          top: '0px',
          right: '0px',
          opacity: 0.05,
        }}
      >
        <i
          className={`fa-solid fa-hashtag`}
          style={{
            color: 'rgba(64, 70, 116, 1)',
            fontSize: '10em',
          }}
        />
      </div>
    </div>
  );
}

export default RFIDCard;
